import React from "react";
import Loader from "src/components/Loader";

interface AudioDialogProps {
  audioInputDialog: boolean;
  voiceLoading: boolean;
  muted: boolean;
  amplitudeRef1: React.RefObject<SVGPathElement>;
  amplitudeRef2: React.RefObject<SVGPathElement>;
  cancelAudio: () => void;
  toggleMute: () => void;
}

export const AudioDialog: React.FC<AudioDialogProps> = ({
  audioInputDialog,
  voiceLoading,
  muted,
  amplitudeRef1,
  amplitudeRef2,
  cancelAudio,
  toggleMute,
}) => {
  if (!audioInputDialog) return null;

  if (voiceLoading) {
    return (
      <div className="flex justify-center items-center p-8 w-full">
        <Loader />
      </div>
    );
  }

  return (
    <div className=" flex items-center justify-center bg-gradient-to-t to-50% from-slate-900 via-none to-none p-12 flex-col">
      <div className={`z-10 rounded-full drop-shadow-2xl relative`}>
        <button onClick={cancelAudio}>
          <svg
            width="155"
            height="154"
            viewBox="0 0 105 104"
            fill="none"
            version="1.1"
            id="svg5"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="m 62.988655,18.164429 c 9.2643,2.9358 20.433,5.83428 23.9175,14.63529 3.4711,8.767 -5.1489,16.5407 -8.1367,25.2232 -3.5316,10.263 -0.1489,25.7492 -10.6745,29.4421 -10.5258,3.6929 -19.4622,-9.4528 -29.2048,-15.4505 -7.5386,-4.641 -17.32454,-7.1431 -20.51328,-15.1574 -3.16816,-7.9625 1.17018,-16.2188 5.10139,-23.5776 3.59939,-6.7377 8.48879,-12.7677 15.81139,-15.56903 7.526,-2.879166 15.8068,-2.047012 23.699,0.45394 z"
              fill="#73d9e8"
              id="path1"
              ref={amplitudeRef1}
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="m 34.612327,31.735727 c 8.3422,-5.31398 17.9412,-12.027078 26.5802,-10.34013 8.6056,1.68042 8.3523,11.65533 12.5445,17.98003 4.9553,7.4761 18.304,12.4381 13.8497,21.841 -4.4545,9.4032 -19.8732,9.5902 -30.7263,13.7848 -8.3979,3.2457 -16.7816,9.1456 -24.659,7.6209 -7.8264,-1.5149 -10.80374,-8.6152 -13.41401,-14.9904 -2.38997,-5.8372 -3.40464,-12.2711 -0.47177,-18.9239 3.01437,-6.8376 9.19008,-12.4454 16.29668,-16.9723 z"
              fill="#42aebe"
              id="path2"
              ref={amplitudeRef2}
            />
            <g
              filter="url(#filter0_d_297_3372)"
              id="g3"
              transform="translate(13.5,15)"
            >
              <rect
                x="7"
                y="3"
                width="64"
                height="64"
                rx="32"
                fill="#077e8f"
                id="rect2"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="m 33.25,31 c 0,-3.1756 2.5744,-5.75 5.75,-5.75 3.1756,0 5.75,2.5744 5.75,5.75 v 3 c 0,3.1756 -2.5744,5.75 -5.75,5.75 -3.1756,0 -5.75,-2.5744 -5.75,-5.75 z M 39,26.75 c -2.3472,0 -4.25,1.9028 -4.25,4.25 v 3 c 0,2.3472 1.9028,4.25 4.25,4.25 2.3472,0 4.25,-1.9028 4.25,-4.25 v -3 c 0,-2.3472 -1.9028,-4.25 -4.25,-4.25 z M 37.25,31 c 0,-0.4142 0.3358,-0.75 0.75,-0.75 h 2 c 0.4142,0 0.75,0.3358 0.75,0.75 0,0.4142 -0.3358,0.75 -0.75,0.75 h -2 c -0.4142,0 -0.75,-0.3358 -0.75,-0.75 z M 31,32.25 c 0.4142,0 0.75,0.3358 0.75,0.75 v 1 c 0,4.0041 3.2459,7.25 7.25,7.25 4.0041,0 7.25,-3.2459 7.25,-7.25 v -1 c 0,-0.4142 0.3358,-0.75 0.75,-0.75 0.4142,0 0.75,0.3358 0.75,0.75 v 1 c 0,4.5798 -3.5186,8.3379 -8,8.7183 V 45 c 0,0.4142 -0.3358,0.75 -0.75,0.75 -0.4142,0 -0.75,-0.3358 -0.75,-0.75 v -2.2817 c -4.4814,-0.3804 -8,-4.1385 -8,-8.7183 v -1 c 0,-0.4142 0.3358,-0.75 0.75,-0.75 z M 36.25,34 c 0,-0.4142 0.3358,-0.75 0.75,-0.75 h 4 c 0.4142,0 0.75,0.3358 0.75,0.75 0,0.4142 -0.3358,0.75 -0.75,0.75 h -4 c -0.4142,0 -0.75,-0.3358 -0.75,-0.75z"
                fill="#ffffff"
                id="path3"
              />
            </g>
            <defs id="defs5">
              <filter
                id="filter0_d_297_3372"
                x="7"
                y="3"
                width="64"
                height="68"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood
                  flood-opacity="0"
                  result="BackgroundImageFix"
                  id="feFlood3"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                  id="feColorMatrix3"
                />
                <feMorphology
                  radius="4"
                  operator="erode"
                  in="SourceAlpha"
                  result="effect1_dropShadow_297_3372"
                  id="feMorphology3"
                />
                <feOffset dy="4" id="feOffset3" />
                <feGaussianBlur stdDeviation="2" id="feGaussianBlur3" />
                <feComposite
                  in2="hardAlpha"
                  operator="out"
                  id="feComposite3"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0.08 0"
                  id="feColorMatrix4"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_297_3372"
                  id="feBlend4"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_297_3372"
                  result="shape"
                  id="feBlend5"
                />
              </filter>
            </defs>
          </svg>
        </button>
      </div>
      <button onClick={toggleMute}>
        <div
          className={`${
            muted ? "bg-red-600" : "bg-white"
          } p-2 rounded-full drop-shadow-lg`}
        >
          {muted ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="size-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.25 9.75 19.5 12m0 0 2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6 4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
              />
            </svg>
          )}
        </div>
      </button>
    </div>
  );
};
